import React, { useState, useEffect } from 'react';
import tech1 from '../assets/images/tech1.png';  // Default image
import BlackArrow from '../assets/images/black-arr.png';
import { techPatient } from '../Adapter/HomePageAdapter';
import { baseImage_path } from "../variables/Variables";
import { NavLink } from 'react-router-dom';

const PatientTech = () => {
    const [techData, setTechData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch data when the component mounts
    useEffect(() => {
        const fetchTechData = async () => {
            try {
                const response = await techPatient();
                if (response && response.data && response.data.length >= 4) {
                    setTechData(response.data.slice(0, 4)); // Get first 4 items
                } else {
                    setError("Not enough data available.");
                }
            } catch (err) {
                setError("An error occurred while fetching data.");
            } finally {
                setLoading(false);
            }
        };

        fetchTechData();
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <>
            <section className="section technology">
                <h2 className="section-title">Cutting Edge Technology <span>For The Patients</span></h2>
                <div className="cust-container">
                    <div className="tech-box">

                        {/* 1st Block - Show Image */}
                        <div className="tech-card ins-crd">
                            {techData[0]?.blog_img ? (
                                <img
                                    src={`${baseImage_path}${techData[0].blog_img}`}
                                    alt={techData[0].name}
                                />
                            ) : (
                                <img src={tech1} alt="Default Technology Image" />
                            )}
                            <div className="box-tehc">
                                <h3>{techData[0]?.name || "Technology"}</h3>
                                {/* <p>{techData[0]?.content || "No description available."}</p> */}
                                <p className="ck-content" dangerouslySetInnerHTML={{ __html: techData[0]?.content }} />
                                <NavLink to="/hospital-technology-service" className="btn with-arr">
                                    Know More <img src={BlackArrow} alt="Arrow" />
                                </NavLink>
                            </div>
                        </div>

                        {/* 2nd & 3rd Block - No Image */}
                        <div className="tech-card ins-crd">
                            <div className="box-tehc this-second-blk">
                                <h3>{techData[1]?.name || "Technology"}</h3>
                                <p>{techData[1]?.content || "No description available."}</p>
                                <NavLink to="/hospital-technology-service" className="btn with-arr">
                                    Know More <img src={BlackArrow} alt="Arrow" />
                                </NavLink>
                            </div>
                            <div className="box-tehc this-third-blk" style={{ marginTop: '15px' }}>
                                <h3>{techData[2]?.name || "Technology"}</h3>
                                {/* <p>{techData[2]?.content || "No description available."}</p> */}
                                <p className="ck-content" dangerouslySetInnerHTML={{ __html: techData[2]?.content }} />
                                <NavLink to="/hospital-technology-service" className="btn with-arr">
                                    Know More <img src={BlackArrow} alt="Arrow" />
                                </NavLink>
                            </div>
                        </div>

                        {/* 4th Block - Show Image */}
                        <div className="tech-card ins-crd">
                            {techData[3]?.blog_img ? (
                                <img
                                    src={`${baseImage_path}${techData[3].blog_img}`}
                                    alt={techData[3].name}
                                />
                            ) : (
                                <img src={tech1} alt="Default Technology Image" />
                            )}
                            <div className="box-tehc">
                                <h3>{techData[3]?.name || "Technology"}</h3>
                                {/* <p>{techData[3]?.content || "No description available."}</p> */}
                                <p className="ck-content" dangerouslySetInnerHTML={{ __html: techData[3]?.content }} />
                                <NavLink to="/hospital-technology-service" className="btn with-arr">
                                    Know More <img src={BlackArrow} alt="Arrow" />
                                </NavLink>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

export default PatientTech;
